export default __webpack_public_path__ + "static/media/c.21a8fab8.svg";